@let currentLesson = lesson();

<div class="td-wb-learn-saved-video__container"
     tdWbDataAnalyticsTagging
     [eventSignal]="eventData">
  <td-wb-card class="td-wb-learn-saved-video__card"
              [id]="uniqueId">
    <td-wb-image-placeholder [aspectRatio]="aspectRatio">
      <div class="td-wb-learn-saved-video__image">
        <img tdWbCardMedia
             aria-hidden="true"
             tdWbDefaultImage
             [alt]="currentLesson.imageUrl"
             [src]="currentLesson.imageUrl">
      </div>
      <td-wb-learn-duration [duration]="currentLesson.duration"
                            [timeRemaining]="currentLesson.timeRemaining" />
    </td-wb-image-placeholder>
    <td-wb-card-content class="td-wb-learn-saved-video__card-content">
      @if (currentLesson.title !== undefined) {
        <div
          class="td-wb-learn-saved-video__content">
          <td-wb-card-subtitle class="td-wb-learn-saved-video__card-subtitle"
                               translate="tdWb.learn.welcome.mostLiked.INFO_LESSON_SUBTITLE" />
          <td-wb-card-title [attr.id]="uniqueId + 'aria'"
                            [innerText]="currentLesson.title" />
        </div>
      }
    </td-wb-card-content>

    <td-wb-card-footer>
      <div class="td-wb-learn-saved-video__card-footer">
        @if (currentLesson.createdDate !== undefined) {
          <div>
            <td-wb-icon class="td-wb-learn-saved-video__card-icon"
                        iconId="calendar-alt--small"
                        [inline]="true" />
            <span [textContent]="currentLesson.createdDate | tdWbDate"></span>
          </div>
        }
        @if (currentLesson.knowledgeLevel !== undefined) {
          <div class="td-wb-learn-saved-video__card-knowledge-level">
            <td-wb-icon class="td-wb-learn-saved-video__card-icon"
                        iconId="graduation-cap--small"
                        [inline]="true" />
            <span [innerText]="currentLesson.knowledgeLevel"></span>
          </div>
        } @else {
          <span>&nbsp;</span>
        }
      </div>
    </td-wb-card-footer>
    <td-wb-card-primary-action [attr.aria-labelledby]="uniqueId + 'aria'"
                               (action)="selectLesson()" />
  </td-wb-card>
  <div class="td-wb-learn-saved-video__action">
    <button [attr.id]="bookmarkUniqueId"
            class="td-wb-learn-saved-video__save"
            tdWbButton
            tdWbButtonType="icon"
            tdWbButtonSize="inline"
            tdWbBlock="spinningWheel"
            [attr.aria-label]="((currentLesson.saved ? 'tdWb.learn.UNSAVE_LESSON' : 'tdWb.learn.SAVE_LESSON') | tdWbTranslate) + ' - ' + currentLesson.title"
            [disabled]="saveDisabled"
            (click)="toggleSave($event)">
      <td-wb-icon [iconId]="currentLesson.saved ? 'bookmark-solid--small' : 'bookmark-outlined--small'"
                  [inline]="true"
                  size="18" />
    </button>
  </div>
</div>

